import api from '~services/axios';

export default {
  apiGetKnowList: params => api.get('/api/knowledgedoc/list', { params }),
  apiDeleteKnowMenu: params => api.post('/api/knowledgemenu/delete', params),
  apiGetTreeData: params => api.get('/api/knowledgemenu/list', { params }),
  apiAddKnowMenu: params => api.post('/api/knowledgemenu/insert', params),
  apiEditKnowMenu: params => api.post('/api/knowledgemenu/update', params),
  apiMoveKnowMenu: params => api.post('/api/knowledgemenu/move', params),
  apiGetKnowDetail: params => api.post('/api/knowledgedoc/get', params),
  apiGetQueryTeam: params => api.get('/api/knowledgedoc/queryteam', params),
  apiGetUploadFile: (params, config) => api.post('/api/knowledgedoc/uploadfile', params, config),
  apiAddKnowDoc: params => api.post('/api/knowledgedoc/insert', params),
  apiUpdateKnowDoc: params => api.post('/api/knowledgedoc/update', params),
  apiKnowTop: params => api.post('/api/knowledgedoc/topcontroll', params),
  apiGetFileList: params => api.get('/api/knowledgedoc/filelist', params),
  apiDeleteKnowDoc: params => api.post('/api/knowledgedoc/delete', params),
};
